import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';

const NEET_TopicModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const [sections, setSections] = useState([]);
    const [filteredSections, setFilteredSections] = useState([]);

    const initialData = {
        Topic: '',
        Section: '',
        SectionID: 0,
        Subject: '',
        SubjectID: 0,
        Sn: 0,
    };

    const [formData, setFormData] = useState(initialData);
    console.log(formData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setFormData(item);
            }
            setModalBox(true);
        }
    }));

    // Fetch subjects & sections
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/subjects')
            .then((res) => {
                res.data.subjects.pop();
                setSubjects(res.data.subjects)
            })
            .catch(() => toast.error('Failed to fetch subjects'));

        axios.get(BACKEND_SERVER_URL + '/neet/sections')
            .then((res) => setSections(res.data.sections))
            .catch(() => toast.error('Failed to fetch sections'));
    }, []);

    // Filter sections when subject changes
    useEffect(() => {
        if (formData.SubjectID) {
            const filtered = sections?.filter(sec => sec.SubjectID === formData.SubjectID);
            console.log(filtered);
            setFilteredSections(filtered);
        } else {
            setFilteredSections([]);
        }
    }, [formData.SubjectID, sections]);

    const handleSave = async () => {
        if (!formData.SubjectID) {
            toast.error("Please select Subject");
            return;
        }
        if (!formData.SectionID) {
            toast.error("Please select Section");
            return;
        }
        if (!formData.Topic.trim()) {
            toast.error("Please enter Topic name");
            return;
        }
        if (formData.Topic.trim().length > 100) {
            toast.error("Topic name cannot exceed 100 characters");
            return;
        }

        try {
            const url = !formData.Sn ? '/neet/createTopic' : '/neet/updateTopic';
            const response = await axios.post(BACKEND_SERVER_URL + url, formData);
            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);
            setModalBox(false);
            setFormData(initialData);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Error saving topic");
        }
    };

    const selectStyles = {
        control: (provided) => ({
            ...provided,
            width: '100%',
            backgroundColor: 'transparent',
            borderColor: '#17a2b8',
        }),
    };

    return (
        <Modal onHide={() => setModalBox(false)} show={modalBox} size="md" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                        {formData.Sn ? "Update Topic" : "Add Topic"}
                    </h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>
                <div className="modal-body">
                    {/* Subject Dropdown */}
                    <div className="mb-3">
                        <label className="form-label text-primary">Subject<span className="required">*</span></label>
                        <Select
                            value={formData.SubjectID ? { value: formData.SubjectID, label: formData.Subject } : null}
                            onChange={(opt) => setFormData({ ...formData, Subject: opt.label, SubjectID: opt.value.Sn, SectionID: 0, Section: '' })}
                            options={subjects.map(s => ({ value: s, label: s.Subject }))}
                            styles={selectStyles}
                            placeholder="Select Subject"
                        // isClearable
                        />
                    </div>

                    {/* Section Dropdown */}
                    <div className="mb-3">
                        <label className="form-label text-primary">Section<span className="required">*</span></label>
                        <Select
                            value={formData.SectionID ? { value: formData.SectionID, label: formData.Section } : null}
                            onChange={(opt) => setFormData({ ...formData, Section: opt.label, SectionID: opt.value.Sn })}
                            options={filteredSections?.map(s => ({ value: s, label: s.Section }))}
                            styles={selectStyles}
                            placeholder="Select Section"
                            // isClearable
                            isDisabled={!formData.SubjectID}
                        />
                    </div>

                    {/* Topic Name */}
                    <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <label className="form-label text-primary mb-1">Topic Name<span className="required">*</span></label>
                            <small className="text-muted">{formData.Topic ? formData.Topic.length : 0}/100</small>
                        </div>
                        <input
                            autoFocus
                            className='form-control'
                            type="text"
                            maxLength={100}
                            value={formData.Topic}
                            onChange={(e) => setFormData({ ...formData, Topic: e.target.value })}
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs" onClick={handleSave}>
                        {formData.Sn ? "Update" : "Add"}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default NEET_TopicModal;
